/* =============================================================================
   PBF Blog — Prikbord index
   Tag-filter via chips + in-place load-more. Werkt door kaarten te tonen/
   verbergen; de masonry-kolommen komen volledig uit CSS (column-count), dus
   er wordt niets in de DOM herstructureerd. Zonder JS: alle kaarten zichtbaar.
   ============================================================================= */

(function () {
  function init(root) {
    var board = root.querySelector('.pbf-prik__board');
    if (!board) return;

    var cards = Array.prototype.slice.call(board.querySelectorAll('.pbf-prik__card'));
    if (!cards.length) return;

    // Kaarten staan in 3 kolom-divs (DOM-volgorde is kolom-gegroepeerd).
    // Sorteer op data-index zodat 'laad meer' de nieuwste eerst toont.
    cards.sort(function (a, b) {
      return (parseInt(a.getAttribute('data-index'), 10) || 0) - (parseInt(b.getAttribute('data-index'), 10) || 0);
    });

    var batch = parseInt(root.getAttribute('data-batch'), 10);
    if (!batch || batch < 1) batch = 6;

    var chips = Array.prototype.slice.call(root.querySelectorAll('.pbf-prik__chip'));
    var counter = root.querySelector('.pbf-prik__counter');
    var moreWrap = root.querySelector('.pbf-prik__more');
    var moreBtn = root.querySelector('.pbf-prik__more-btn');
    var endMsg = root.querySelector('.pbf-prik__end');

    var state = { tag: 'all', shown: batch };

    if (moreWrap) moreWrap.hidden = false;

    function matchesTag(card) {
      if (state.tag === 'all') return true;
      var tags = (card.getAttribute('data-tags') || '').split(',');
      return tags.indexOf(state.tag) !== -1;
    }

    function render() {
      var total = 0;
      var shownCount = 0;

      cards.forEach(function (card) {
        if (matchesTag(card)) {
          total++;
          if (shownCount < state.shown) {
            card.classList.remove('is-hidden');
            shownCount++;
          } else {
            card.classList.add('is-hidden');
          }
        } else {
          card.classList.add('is-hidden');
        }
      });

      if (counter) {
        counter.textContent = total + (total === 1 ? ' verhaal' : ' verhalen');
      }

      var hasMore = shownCount < total;
      var everNeeded = total > batch;
      if (moreWrap) moreWrap.hidden = !everNeeded;
      if (moreBtn) moreBtn.style.display = hasMore ? '' : 'none';
      if (endMsg) endMsg.hidden = hasMore || !everNeeded;
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        state.tag = chip.getAttribute('data-tag') || 'all';
        state.shown = batch;
        render();
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        state.shown += batch;
        render();
      });
    }

    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.pbf-prik'), function (root) {
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
